'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { Provider as TooltipProvider } from '@radix-ui/react-tooltip';
import { ThemeProvider } from '@repo/ui';
export interface DappUIWrapperProviderProps extends PropsWithChildren {
  /** Per-request CSP nonce for the next-themes boot script. */
  nonce?: string;
}

/**
 * Mounts the shared `@repo/ui` ThemeProvider (next-themes) plus a radix
 * TooltipProvider.
 *
 * ui-v6's UiV6Provider supplies only the dialog + toast contexts (no
 * Tooltip.Provider), so the radix TooltipProvider is still required here for
 * ui-v6 Tooltip / HoverCard usage.
 */
export const DappUIWrapperProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    nonce
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TooltipProvider>{children}</TooltipProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== nonce || $[3] !== t1) {
    t2 = <ThemeProvider nonce={nonce}>{t1}</ThemeProvider>;
    $[2] = nonce;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};